import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import Login from './pages/Login';
import Users from './pages/Users';
import Channels from './pages/Channels';
import PortalUsers from './pages/PortalUsers';
import Sidebar from './components/Sidebar';
import { AuthProvider, useAuth } from './context/AuthContext';

const PrivateLayout = ({ children }) => {
  const { isAuthenticated, userRole } = useAuth();

  if (!isAuthenticated) {
    return <Navigate to="/login" />;
  }

  return (
    <div className="flex h-screen bg-gray-100">
      <Sidebar userRole={userRole} />
      <div className="flex-1 overflow-auto p-6">{children}</div>
    </div>
  );
};

const AdminRoute = ({ children }) => {
  const { isAuthenticated, userRole } = useAuth();

  if (!isAuthenticated) {
    return <Navigate to="/login" />;
  }

  if (userRole !== 'admin') {
    return <Navigate to="/users" />;
  }

  return children;
};

function App() {
  return (
    <AuthProvider>
      <Router>
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route path="/users" element={<PrivateLayout><Users /></PrivateLayout>} />
          <Route path="/channels" element={<PrivateLayout><Channels /></PrivateLayout>} />
          <Route path="/portal-users" element={<PrivateLayout><AdminRoute><PortalUsers /></AdminRoute></PrivateLayout>} />
          <Route path="/" element={<Navigate to="/users" />} />
        </Routes>
      </Router>
    </AuthProvider>
  );
}

export default App;
